import { Pipe, PipeTransform } from "@angular/core";
import { HardTranslatePipe } from "@hardcode-kz/ui";
import { IUserRole } from "@models/user-management/user-role";

@Pipe({
  name: "roleNames",
  pure: false,
  standalone: false,
})
export class RoleNamesPipe implements PipeTransform {
  constructor(private readonly translate: HardTranslatePipe) {}

  transform(roles: IUserRole[] | null | undefined, sep = ", "): string {
    if (!Array.isArray(roles) || !roles.length) {
      return "";
    }
    return roles.map((r) => this.translate.transform(r?.name)).join(sep);
  }
}
